import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import VideoPlayer from '@/components/VideoPlayer.vue'
  import useVideo from '@/composables/useVideo'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import type { PropType } from 'vue'
  import type { GetStartedStepEntity } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GetStartedOnboardingModal',
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    thumbnailTimestamp: {
      type: Number,
      default: 0,
    },
    activeStepEntity: {
      type: String as PropType<GetStartedStepEntity>,
      required: true,
    },
  },
  emits: ['close'],
  setup(__props) {

const props = __props;

  
  
  const { getPosterImage } = useVideo()

  const posterImage = computed(() => {
    return getPosterImage(props.videoUrl, props.thumbnailTimestamp)
  })

return { __sfc: true,props, getPosterImage, posterImage, computed, VideoPlayer, useVideo, KetchUpButton }
}

})